import React, { useRef, useState } from "react";
// Components
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import InputField from "../../Shared/inputField/inputField";

// Styles
import Styles from "../../Shared/sharedStyles.module.scss";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

// Constants

// Function
import { validIFSCNumber } from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function IfscServicePopup({ handleResponse }: any) {
  const errorObject = {
    ifscNumberError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const ifscNumberRef = useRef<any>("");

  function isValid() {
    if (validIFSCNumber(ifscNumberRef.current.value.trim().toUpperCase())) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    setError(() => ({
      ...error,
      ifscNumberError: true,
    }));
    return setIsDisabled(true);
  }

  function handleCheck() {
    const ifscNumber = ifscNumberRef.current.value.toUpperCase();

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }

    const consent = isChecked === true ? "Y" : "N";
    setLoading(true);
    handleResponse({ ifscNumber, consent }, setLoading);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>IFSC Number</label>
            <InputField
              id={IdsGenerator({
                prefix: "ifsc popup",
                id: "change",
                suffix: "ifsc",
              })}
              onChange={isValid}
              maxLength={11}
              inputRef={ifscNumberRef}
              isError={error.ifscNumberError}
              purpose="forIfsc"
            />
            {error.ifscNumberError && (
              <ErrorMessage>Please enter a valid IFSC number</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: "ifsc popup",
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: "ifsc popup",
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: "ifsc popup",
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IfscServicePopup;
